var map = {
	"./approved.svg": 43183,
	"./approved_icon.svg": 41363,
	"./approved_icon_thin.svg": 70790,
	"./approved_white.svg": 64531,
	"./arrow_back.svg": 47695,
	"./attachment.svg": 76056,
	"./audio_play.svg": 28070,
	"./audio_stop.svg": 63685,
	"./beware_of_the_origin.svg": 5327,
	"./calendar.svg": 27955,
	"./camera.svg": 91650,
	"./check.svg": 13605,
	"./clock.svg": 55093,
	"./commitment_to_the_climate.svg": 5385,
	"./denied_white.svg": 23302,
	"./deny.svg": 65707,
	"./eco_friendly_packaging.svg": 20775,
	"./edit.svg": 976,
	"./flags_ARG.svg": 64717,
	"./flags_AVON_ARG.svg": 22050,
	"./flags_BOL.svg": 24318,
	"./flags_BRA.svg": 71036,
	"./flags_CHL.svg": 44551,
	"./flags_COL.svg": 43695,
	"./flags_FRA.svg": 49657,
	"./flags_GBR.svg": 25694,
	"./flags_MEX.svg": 19184,
	"./flags_MYS.svg": 84619,
	"./flags_PER.svg": 94041,
	"./flags_USA.svg": 18547,
	"./form_checkbox_filled.svg": 35318,
	"./form_checkbox_unfilled.svg": 33851,
	"./help_outline.svg": 66495,
	"./help_outline2.svg": 35085,
	"./microphone.svg": 31351,
	"./money.svg": 21252,
	"./natural_formulas.svg": 66804,
	"./no_animal_testing.svg": 85919,
	"./processing_icon_thin.svg": 91090,
	"./rejection_icon.svg": 38794,
	"./safe_for_you_and_environment.svg": 15183,
	"./social_facebook.svg": 90898,
	"./social_instagram.svg": 40481,
	"./social_twitter.svg": 28764,
	"./social_vimeo.svg": 42726,
	"./social_youtube.svg": 27211,
	"./stop.svg": 19022,
	"./trash.svg": 78126,
	"./ui_checked.svg": 87759,
	"./ui_delete.svg": 88721,
	"./ui_filters.svg": 16720,
	"./ui_fullscreen_off.svg": 7847,
	"./ui_fullscreen_on.svg": 24615,
	"./ui_home.svg": 22039,
	"./ui_mail.svg": 81210,
	"./ui_office.svg": 87458,
	"./ui_remove.svg": 44231,
	"./ui_replay.svg": 977,
	"./upload_photo.svg": 80358,
	"./warning_circle.svg": 50646
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84405;